<template>
  <div>
        <dropper :index="index" :level="2"></dropper>
        <div  v-if="$parent.editMode"  class="delete is-pulled-right" @click="remove"></div>
        <div class="top10 bottom10" style="border-bottom: 2px dotted #f1c232" :class="{bottom30: !$parent.editMode}"></div>
  </div>
</template>

<script>

import dropper from './sectionDropper.vue'

export default {
    props: {params: Object, index: Number},
    components: {dropper},
    data: function(){
        return {
            
        }
    },

    methods: {

      remove: function(){
          this.$parent.removeSection(this.index)
      }
    }

 
}

</script>